import { ProductForm } from "@/components/products/ProductForm";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useCreateProduct } from "@/hooks/use-products";

interface ProductCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ProductCreateDialog({ open, onOpenChange }: ProductCreateDialogProps) {
  const createProduct = useCreateProduct();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New product</DialogTitle>
          <DialogDescription>Add a product to your catalog.</DialogDescription>
        </DialogHeader>
        <ProductForm
          submitLabel="Create"
          isSaving={createProduct.isPending}
          onCancel={() => onOpenChange(false)}
          onSubmit={(result) =>
            createProduct.mutate(result, { onSuccess: () => onOpenChange(false) })
          }
        />
      </DialogContent>
    </Dialog>
  );
}
